
import { useDisciplineStore } from '@entities/customer/@x/subscription'
import { useCsRoutes } from '@shared/api'

import { useSubscriptionStore } from '../model/subscription-store/store'

export const useSubscriptionListApi = async (): Promise<any> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()
  const subscriptionStore = useSubscriptionStore()

  const id = disciplineStore.activeDiscipline?.id || null

  if (id) {
    const url = useCsRoutes('subscription.list', {
      '[discipline_id]': id,
    })
    try {
      const { data } = await $axios.get(url!)

      subscriptionStore.setSubscriptions(data.data)

      return data.data
    } catch (err) {
      console.error(err)
      return null
    }
  } else {
    return null
  }
}
